var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "air-box", class: { "p-0": !_vm.response } },
    [
      _c(
        "div",
        {
          staticClass: "wrapper flex-around flex-col",
          class: { shadow: _vm.shadow, fixed: !_vm.response },
        },
        [
          _c("p", { staticClass: "name" }, [
            _vm._v(_vm._s(_vm.air.deviceName)),
          ]),
          _c("canvas", { ref: "canvas", staticClass: "canvas" }),
          _c("div", { staticClass: "pointer img" }, [
            _vm.air.switchstate === "on" &&
            (_vm.air.mode === "cold" || _vm.air.mode === "wind")
              ? _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      fill: "none",
                      version: "1.1",
                      width: "80",
                      height: "80",
                      viewBox: "0 0 100 100",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.toggleAir("off")
                      },
                    },
                  },
                  [
                    _c(
                      "defs",
                      [
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              x1: "0.5",
                              y1: "-3.0616171314629196e-17",
                              x2: "0.5",
                              y2: "1",
                              id: "master_svg0_24_1833",
                            },
                          },
                          [
                            _c("stop", {
                              attrs: {
                                offset: "1.4285714365541935%",
                                "stop-color": "#000000",
                                "stop-opacity": "1",
                              },
                            }),
                            _c("stop", {
                              attrs: {
                                offset: "100%",
                                "stop-color": "#000000",
                                "stop-opacity": "1",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              x1: "0.5",
                              y1: "-3.0616171314629196e-17",
                              x2: "0.5",
                              y2: "1",
                              id: "master_svg1_0_1322",
                            },
                          },
                          [
                            _c("stop", {
                              attrs: {
                                offset: "0%",
                                "stop-color": "#000000",
                                "stop-opacity": "0.6299999952316284",
                              },
                            }),
                            _c("stop", {
                              attrs: {
                                offset: "100%",
                                "stop-color": "#4A4848",
                                "stop-opacity": "1",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              x1: "0.5",
                              y1: "-3.0616171314629196e-17",
                              x2: "0.5",
                              y2: "1",
                              id: "master_svg2_0_1325",
                            },
                          },
                          [
                            _c("stop", {
                              attrs: {
                                offset: "0%",
                                "stop-color": "#38393E",
                                "stop-opacity": "1",
                              },
                            }),
                            _c("stop", {
                              attrs: {
                                offset: "22.69131988286972%",
                                "stop-color": "#38393E",
                                "stop-opacity": "1",
                              },
                            }),
                            _c("stop", {
                              attrs: {
                                offset: "100%",
                                "stop-color": "#18191D",
                                "stop-opacity": "1",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "filter",
                          {
                            attrs: {
                              id: "master_svg3_0_6738",
                              filterUnits: "objectBoundingBox",
                              "color-interpolation-filters": "sRGB",
                              x: "-4",
                              y: "-5",
                              width: "40.05714416503906",
                              height: "41",
                            },
                          },
                          [
                            _c("feFlood", {
                              attrs: {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix",
                              },
                            }),
                            _c("feColorMatrix", {
                              attrs: {
                                in: "SourceAlpha",
                                type: "matrix",
                                values:
                                  "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                              },
                            }),
                            _c("feOffset", { attrs: { dy: "-1", dx: "0" } }),
                            _c("feGaussianBlur", {
                              attrs: { stdDeviation: "1" },
                            }),
                            _c("feColorMatrix", {
                              attrs: {
                                type: "matrix",
                                values:
                                  "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0",
                              },
                            }),
                            _c("feBlend", {
                              attrs: {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow",
                              },
                            }),
                            _c("feBlend", {
                              attrs: {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow",
                                result: "shape",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "g",
                      { staticStyle: { "mix-blend-mode": "passthrough" } },
                      [
                        _c(
                          "g",
                          { staticStyle: { "mix-blend-mode": "passthrough" } },
                          [
                            _c(
                              "g",
                              {
                                staticStyle: {
                                  "mix-blend-mode": "passthrough",
                                },
                              },
                              [
                                _c("ellipse", {
                                  attrs: {
                                    cx: "50",
                                    cy: "50",
                                    rx: "38",
                                    ry: "38",
                                    fill: "url(#master_svg0_24_1833)",
                                    "fill-opacity": "0.20000000298023224",
                                  },
                                }),
                                _c("ellipse", {
                                  attrs: {
                                    cx: "50",
                                    cy: "50",
                                    rx: "39",
                                    ry: "39",
                                    stroke: "url(#master_svg1_0_1322)",
                                    "fill-opacity": "0",
                                    fill: "none",
                                    "stroke-width": "2",
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "g",
                              {
                                staticStyle: {
                                  "mix-blend-mode": "passthrough",
                                },
                              },
                              [
                                _c("ellipse", {
                                  attrs: {
                                    cx: "50",
                                    cy: "50",
                                    rx: "36",
                                    ry: "36",
                                    fill: "url(#master_svg2_0_1325)",
                                    "fill-opacity": "1",
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "g",
                              {
                                staticStyle: {
                                  "mix-blend-mode": "passthrough",
                                },
                                attrs: { filter: "url(#master_svg3_0_6738)" },
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "mix-blend-mode": "passthrough",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M41.08821000000182,36.04469208807373C36.25652000000182,38.80543308807373,33.00000000000182,44.008133088073734,33.00000000000182,49.971423088073735C33.00000000000182,58.823723088073734,40.17624000000182,66.00002308807373,49.028600000001816,66.00002308807373C57.880900000001816,66.00002308807373,65.05710000000181,58.823723088073734,65.05710000000181,49.971423088073735C65.05710000000181,44.43176308807373,62.246900000001816,39.54847308807373,57.974200000001815,36.66943308807373C57.35870000000182,36.25470408807373,56.571400000001816,36.70786308807373,56.571400000001816,37.45003308807373C56.571400000001816,37.45726308807373,56.571400000001816,37.46445308807373,56.571400000001816,37.47160308807373C56.571400000001816,37.80873308807373,56.74480000000182,38.11226308807373,57.02280000000182,38.30306308807373C60.73600000000182,40.85193308807373,63.17140000000182,45.12727308807373,63.17140000000182,49.971423088073735C63.17140000000182,57.78232308807373,56.83950000000182,64.11432308807373,49.028600000001816,64.11432308807373C41.21769000000182,64.11432308807373,34.88571000000182,57.78232308807373,34.88571000000182,49.971423088073735C34.88571000000182,44.75286308807373,37.712160000001816,40.19445308807373,41.91771000000182,37.74352308807373C42.23003000000182,37.56151308807373,42.42857000000182,37.24407308807373,42.42857000000182,36.88258308807373C42.42857000000182,36.87784308807373,42.42857000000182,36.87308308807373,42.42857000000182,36.86830308807373C42.42857000000182,36.15971108807373,41.70346000000182,35.69315308807373,41.08822000000182,36.04469108807373",
                                        "fill-rule": "evenodd",
                                        fill: "#1890FF",
                                        "fill-opacity": "1",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "mix-blend-mode": "passthrough",
                                    },
                                  },
                                  [
                                    _c("rect", {
                                      attrs: {
                                        x: "48.08571434020996",
                                        y: "33",
                                        width: "1.8857142925262451",
                                        height: "9.428571701049805",
                                        rx: "0.9428571462631226",
                                        fill: "#1890FF",
                                        "fill-opacity": "1",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              : _vm.air.switchstate === "on" && _vm.air.mode === "heat"
              ? _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      fill: "none",
                      version: "1.1",
                      width: "80",
                      height: "80",
                      viewBox: "0 0 80 80",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.toggleAir("off")
                      },
                    },
                  },
                  [
                    _c(
                      "defs",
                      [
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              x1: "0.5",
                              y1: "-3.0616171314629196e-17",
                              x2: "0.5",
                              y2: "1",
                              id: "master_svg0_0_1320",
                            },
                          },
                          [
                            _c("stop", {
                              attrs: {
                                offset: "0%",
                                "stop-color": "#000000",
                                "stop-opacity": "1",
                              },
                            }),
                            _c("stop", {
                              attrs: {
                                offset: "100%",
                                "stop-color": "#000000",
                                "stop-opacity": "1",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              x1: "0.5",
                              y1: "-3.0616171314629196e-17",
                              x2: "0.5",
                              y2: "1",
                              id: "master_svg1_0_1322",
                            },
                          },
                          [
                            _c("stop", {
                              attrs: {
                                offset: "0%",
                                "stop-color": "#000000",
                                "stop-opacity": "0.6299999952316284",
                              },
                            }),
                            _c("stop", {
                              attrs: {
                                offset: "100%",
                                "stop-color": "#4A4848",
                                "stop-opacity": "1",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              x1: "0.5",
                              y1: "-3.0616171314629196e-17",
                              x2: "0.5",
                              y2: "1",
                              id: "master_svg2_0_1325",
                            },
                          },
                          [
                            _c("stop", {
                              attrs: {
                                offset: "0%",
                                "stop-color": "#38393E",
                                "stop-opacity": "1",
                              },
                            }),
                            _c("stop", {
                              attrs: {
                                offset: "22.69131988286972%",
                                "stop-color": "#38393E",
                                "stop-opacity": "1",
                              },
                            }),
                            _c("stop", {
                              attrs: {
                                offset: "100%",
                                "stop-color": "#18191D",
                                "stop-opacity": "1",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "filter",
                          {
                            attrs: {
                              id: "master_svg3_0_6835",
                              filterUnits: "objectBoundingBox",
                              "color-interpolation-filters": "sRGB",
                              x: "-4",
                              y: "-5",
                              width: "33.64571571350098",
                              height: "34.40000343322754",
                            },
                          },
                          [
                            _c("feFlood", {
                              attrs: {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix",
                              },
                            }),
                            _c("feColorMatrix", {
                              attrs: {
                                in: "SourceAlpha",
                                type: "matrix",
                                values:
                                  "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                              },
                            }),
                            _c("feOffset", { attrs: { dy: "-1", dx: "0" } }),
                            _c("feGaussianBlur", {
                              attrs: { stdDeviation: "1" },
                            }),
                            _c("feColorMatrix", {
                              attrs: {
                                type: "matrix",
                                values:
                                  "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0",
                              },
                            }),
                            _c("feBlend", {
                              attrs: {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow",
                              },
                            }),
                            _c("feBlend", {
                              attrs: {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow",
                                result: "shape",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "g",
                      { staticStyle: { "mix-blend-mode": "passthrough" } },
                      [
                        _c(
                          "g",
                          { staticStyle: { "mix-blend-mode": "passthrough" } },
                          [
                            _c(
                              "g",
                              {
                                staticStyle: {
                                  "mix-blend-mode": "passthrough",
                                },
                              },
                              [
                                _c("ellipse", {
                                  attrs: {
                                    cx: "39.999999046325684",
                                    cy: "39.999999046325684",
                                    rx: "30.399999618530273",
                                    ry: "30.399999618530273",
                                    fill: "url(#master_svg0_0_1320)",
                                    "fill-opacity": "0.20000000298023224",
                                  },
                                }),
                                _c("ellipse", {
                                  attrs: {
                                    cx: "39.999999046325684",
                                    cy: "39.999999046325684",
                                    rx: "31.399999618530273",
                                    ry: "31.399999618530273",
                                    stroke: "url(#master_svg1_0_1322)",
                                    "fill-opacity": "0",
                                    fill: "none",
                                    "stroke-width": "2",
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "g",
                              {
                                staticStyle: {
                                  "mix-blend-mode": "passthrough",
                                },
                              },
                              [
                                _c("ellipse", {
                                  attrs: {
                                    cx: "39.99999666213989",
                                    cy: "39.99999666213989",
                                    rx: "28.799997329711914",
                                    ry: "28.799997329711914",
                                    fill: "url(#master_svg2_0_1325)",
                                    "fill-opacity": "1",
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "g",
                              {
                                staticStyle: {
                                  "mix-blend-mode": "passthrough",
                                },
                                attrs: { filter: "url(#master_svg3_0_6835)" },
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "mix-blend-mode": "passthrough",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M32.87056866485596,28.835752230682374C29.005218664855956,31.044347230682373,26.399998664855957,35.20650723068238,26.399998664855957,39.977137230682374C26.399998664855957,47.05903723068238,32.14098866485595,52.80003723068238,39.22289866485596,52.80003723068238C46.304698664855955,52.80003723068238,52.04569866485596,47.05903723068238,52.04569866485596,39.977137230682374C52.04569866485596,35.54540723068237,49.79749866485596,31.638777230682372,46.379398664855955,29.335537230682373C45.88699866485595,29.003762230682373,45.25709866485596,29.366297230682374,45.25709866485596,29.96002723068237C45.25709866485596,29.965807230682373,45.25709866485596,29.971567230682375,45.25709866485596,29.977277230682372C45.25709866485596,30.24698723068237,45.395898664855956,30.489807230682374,45.61819866485595,30.64244723068237C48.58879866485596,32.68154723068237,50.53709866485596,36.10181723068237,50.53709866485596,39.977137230682374C50.53709866485596,46.22583723068237,45.47159866485596,51.29143723068238,39.22289866485596,51.29143723068238C32.97414866485596,51.29143723068238,27.908568664855956,46.22583723068237,27.908568664855956,39.977137230682374C27.908568664855956,35.80229723068237,30.169728664855956,32.15556723068237,33.534168664855954,30.19481723068237C33.78402866485596,30.049207230682374,33.942858664855954,29.795257230682374,33.942858664855954,29.506067230682373C33.942858664855954,29.502267230682374,33.942858664855954,29.498457230682373,33.942858664855954,29.494637230682372C33.942858664855954,28.927767230682374,33.362768664855956,28.554521230682372,32.87056866485596,28.835752230682374",
                                        "fill-rule": "evenodd",
                                        fill: "#F2BC53",
                                        "fill-opacity": "1",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "mix-blend-mode": "passthrough",
                                    },
                                  },
                                  [
                                    _c("rect", {
                                      attrs: {
                                        x: "38.46857166290283",
                                        y: "26.399998664855957",
                                        width: "1.5085703134536743",
                                        height: "7.5428595542907715",
                                        rx: "0.7542851567268372",
                                        fill: "#F2BC53",
                                        "fill-opacity": "1",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              : _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      "xmlns:xlink": "http://www.w3.org/1999/xlink",
                      fill: "none",
                      version: "1.1",
                      width: "80",
                      height: "80",
                      viewBox: "0 0 80 80",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.toggleAir("on")
                      },
                    },
                  },
                  [
                    _c(
                      "defs",
                      [
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              x1: "0.5",
                              y1: "-3.0616171314629196e-17",
                              x2: "0.5",
                              y2: "1",
                              id: "master_svg0_0_1320",
                            },
                          },
                          [
                            _c("stop", {
                              attrs: {
                                offset: "0%",
                                "stop-color": "#000000",
                                "stop-opacity": "1",
                              },
                            }),
                            _c("stop", {
                              attrs: {
                                offset: "100%",
                                "stop-color": "#000000",
                                "stop-opacity": "1",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              x1: "0.5",
                              y1: "-3.0616171314629196e-17",
                              x2: "0.5",
                              y2: "1",
                              id: "master_svg1_0_1322",
                            },
                          },
                          [
                            _c("stop", {
                              attrs: {
                                offset: "0%",
                                "stop-color": "#000000",
                                "stop-opacity": "0.6299999952316284",
                              },
                            }),
                            _c("stop", {
                              attrs: {
                                offset: "100%",
                                "stop-color": "#4A4848",
                                "stop-opacity": "1",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "linearGradient",
                          {
                            attrs: {
                              x1: "0.5",
                              y1: "-3.0616171314629196e-17",
                              x2: "0.5",
                              y2: "1",
                              id: "master_svg2_0_1325",
                            },
                          },
                          [
                            _c("stop", {
                              attrs: {
                                offset: "0%",
                                "stop-color": "#38393E",
                                "stop-opacity": "1",
                              },
                            }),
                            _c("stop", {
                              attrs: {
                                offset: "22.69131988286972%",
                                "stop-color": "#38393E",
                                "stop-opacity": "1",
                              },
                            }),
                            _c("stop", {
                              attrs: {
                                offset: "100%",
                                "stop-color": "#18191D",
                                "stop-opacity": "1",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "filter",
                          {
                            attrs: {
                              id: "master_svg3_0_6748",
                              filterUnits: "objectBoundingBox",
                              "color-interpolation-filters": "sRGB",
                              x: "-4",
                              y: "-5",
                              width: "33.64571571350098",
                              height: "34.40000343322754",
                            },
                          },
                          [
                            _c("feFlood", {
                              attrs: {
                                "flood-opacity": "0",
                                result: "BackgroundImageFix",
                              },
                            }),
                            _c("feColorMatrix", {
                              attrs: {
                                in: "SourceAlpha",
                                type: "matrix",
                                values:
                                  "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                              },
                            }),
                            _c("feOffset", { attrs: { dy: "-1", dx: "0" } }),
                            _c("feGaussianBlur", {
                              attrs: { stdDeviation: "1" },
                            }),
                            _c("feColorMatrix", {
                              attrs: {
                                type: "matrix",
                                values:
                                  "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0",
                              },
                            }),
                            _c("feBlend", {
                              attrs: {
                                mode: "normal",
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow",
                              },
                            }),
                            _c("feBlend", {
                              attrs: {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow",
                                result: "shape",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "g",
                      { staticStyle: { "mix-blend-mode": "passthrough" } },
                      [
                        _c(
                          "g",
                          { staticStyle: { "mix-blend-mode": "passthrough" } },
                          [
                            _c(
                              "g",
                              {
                                staticStyle: {
                                  opacity: "0.5",
                                  "mix-blend-mode": "passthrough",
                                },
                              },
                              [
                                _c("ellipse", {
                                  attrs: {
                                    cx: "39.999999046325684",
                                    cy: "39.999999046325684",
                                    rx: "30.399999618530273",
                                    ry: "30.399999618530273",
                                    fill: "url(#master_svg0_0_1320)",
                                    "fill-opacity": "0.20000000298023224",
                                  },
                                }),
                                _c("ellipse", {
                                  attrs: {
                                    cx: "39.999999046325684",
                                    cy: "39.999999046325684",
                                    rx: "31.399999618530273",
                                    ry: "31.399999618530273",
                                    stroke: "url(#master_svg1_0_1322)",
                                    "fill-opacity": "0",
                                    fill: "none",
                                    "stroke-width": "2",
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "g",
                              {
                                staticStyle: {
                                  "mix-blend-mode": "passthrough",
                                },
                              },
                              [
                                _c("ellipse", {
                                  attrs: {
                                    cx: "39.99999666213989",
                                    cy: "39.99999666213989",
                                    rx: "28.799997329711914",
                                    ry: "28.799997329711914",
                                    fill: "url(#master_svg2_0_1325)",
                                    "fill-opacity": "1",
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "g",
                              {
                                staticStyle: {
                                  "mix-blend-mode": "passthrough",
                                },
                                attrs: { filter: "url(#master_svg3_0_6748)" },
                              },
                              [
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "mix-blend-mode": "passthrough",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M32.87056866485596,28.835752230682374C29.005218664855956,31.044347230682373,26.399998664855957,35.20650723068238,26.399998664855957,39.977137230682374C26.399998664855957,47.05903723068238,32.14098866485595,52.80003723068238,39.22289866485596,52.80003723068238C46.304698664855955,52.80003723068238,52.04569866485596,47.05903723068238,52.04569866485596,39.977137230682374C52.04569866485596,35.54540723068237,49.79749866485596,31.638777230682372,46.379398664855955,29.335537230682373C45.88699866485595,29.003762230682373,45.25709866485596,29.366297230682374,45.25709866485596,29.96002723068237C45.25709866485596,29.965807230682373,45.25709866485596,29.971567230682375,45.25709866485596,29.977277230682372C45.25709866485596,30.24698723068237,45.395898664855956,30.489807230682374,45.61819866485595,30.64244723068237C48.58879866485596,32.68154723068237,50.53709866485596,36.10181723068237,50.53709866485596,39.977137230682374C50.53709866485596,46.22583723068237,45.47159866485596,51.29143723068238,39.22289866485596,51.29143723068238C32.97414866485596,51.29143723068238,27.908568664855956,46.22583723068237,27.908568664855956,39.977137230682374C27.908568664855956,35.80229723068237,30.169728664855956,32.15556723068237,33.534168664855954,30.19481723068237C33.78402866485596,30.049207230682374,33.942858664855954,29.795257230682374,33.942858664855954,29.506067230682373C33.942858664855954,29.502267230682374,33.942858664855954,29.498457230682373,33.942858664855954,29.494637230682372C33.942858664855954,28.927767230682374,33.362768664855956,28.554521230682372,32.87056866485596,28.835752230682374",
                                        "fill-rule": "evenodd",
                                        fill: "#999999",
                                        "fill-opacity": "0.6000000238418579",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "g",
                                  {
                                    staticStyle: {
                                      "mix-blend-mode": "passthrough",
                                    },
                                  },
                                  [
                                    _c("rect", {
                                      attrs: {
                                        x: "38.46857166290283",
                                        y: "26.399998664855957",
                                        width: "1.5085703134536743",
                                        height: "7.5428595542907715",
                                        rx: "0.7542851567268372",
                                        fill: "#999999",
                                        "fill-opacity": "0.6000000238418579",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
          ]),
          _c(
            "div",
            {
              staticClass: "flex-between res",
              class: {
                on: _vm.air.switchstate === "on",
                heat: _vm.air.mode === "heat",
                cold: _vm.air.mode === "cold" || _vm.air.mode === "wind",
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "svg",
                  class: { active: _vm.air.mode === "cold" },
                  attrs: {
                    t: "1679966763975",
                    viewBox: "0 0 1024 1024",
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "p-id": "2279",
                    width: "32",
                    height: "32",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeMode("cold")
                    },
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M897.22368 446.446592C895.0272 446.446592 892.786688 446.160896 890.564608 445.553664L746.604544 406.71744C741.357568 405.302272 736.939008 402.33984 733.677568 398.45888L546.226176 507.445248 740.31616 620.291072C742.247424 619.15648 744.34048 618.235904 746.604544 617.6256L890.564608 578.78016C904.249344 575.062016 918.336512 583.26528 921.99424 597.055488 925.663232 610.844672 917.541888 625.012736 903.84896 628.706304L802.039808 656.178176 893.188096 709.172224C901.376 713.934848 904.173568 724.467712 899.452928 732.71296 896.279552 738.240512 890.53184 741.327872 884.617216 741.327872 881.716224 741.327872 878.777344 740.589568 876.077056 739.022848L777.892864 681.93792 808.14592 795.629568C811.813888 809.419776 803.693568 823.58784 789.999616 827.280384 787.777536 827.886592 785.537024 828.173312 783.340544 828.173312 772.011008 828.173312 761.63584 820.558848 758.569984 809.007104L719.995904 664.04352C718.590976 658.761728 718.927872 653.428736 720.631808 648.645632L529.61792 537.587712 529.61792 763.502592C532.95104 764.758016 536.08448 766.712832 538.766336 769.41312L644.151296 875.532288C654.17728 885.620736 654.17728 901.984256 644.151296 912.079872 639.138816 917.128192 632.571904 919.653376 626.004992 919.653376 619.437056 919.653376 612.871168 917.128192 607.859712 912.079872L529.61792 833.294336 529.61792 943.024128C529.61792 952.539136 521.834496 960.256 512.236544 960.256 502.637568 960.256 494.854144 952.539136 494.854144 943.024128L494.854144 833.1264 416.451584 912.079872C411.440128 917.128192 404.873216 919.653376 398.306304 919.653376 391.739392 919.653376 385.17248 917.128192 380.158976 912.079872 370.134016 901.993472 370.134016 885.620736 380.158976 875.532288L485.536768 769.41312C488.26368 766.666752 491.457536 764.695552 494.854144 763.4432L494.854144 537.31328 303.369216 648.644608C305.074176 653.428736 305.412096 658.760704 304.007168 664.04352L265.44128 809.007104C262.376448 820.550656 251.998208 828.173312 240.669696 828.173312 238.472192 828.173312 236.232704 827.886592 234.0096 827.280384 220.316672 823.58784 212.195328 809.419776 215.86432 795.629568L246.111232 681.935872 148.225024 738.847744C145.533952 740.411392 142.584832 741.152768 139.684864 741.152768 133.77024 741.152768 128.023552 738.064384 124.849152 732.536832 120.127488 724.292608 122.92608 713.757696 131.115008 708.996096L221.961216 656.177152 120.16128 628.706304C106.467328 625.012736 98.347008 610.844672 102.014976 597.055488 105.68192 583.26528 119.77728 575.062016 133.445632 578.78016L277.397504 617.6256C279.660544 618.235904 281.754624 619.15648 283.684864 620.291072L477.773824 507.445248 290.323456 398.45888C287.06304 402.33984 282.64448 405.302272 277.397504 406.71744L133.445632 445.553664C131.222528 446.160896 128.985088 446.446592 126.78656 446.446592 115.457024 446.446592 105.081856 438.832128 102.014976 427.281408 98.347008 413.4912 106.467328 399.322112 120.16128 395.628544L233.064448 365.167616 135.175168 308.25472C126.988288 303.49312 124.188672 292.958208 128.909312 284.713984 133.63712 276.476928 144.072704 273.642496 152.285184 278.404096L243.13856 331.227136 215.86432 228.70528C212.195328 214.91712 220.316672 200.748032 234.0096 197.054464 247.712768 193.327104 261.782528 201.53856 265.44128 215.328768L304.007168 360.292352C304.613376 362.5728 304.868352 364.859392 304.858112 367.111168L494.854144 477.577216 494.854144 260.723712C491.457536 259.47136 488.26368 257.50016 485.536768 254.754816L380.158976 148.627456C370.134016 138.529792 370.134016 122.166272 380.158976 112.078848 390.18496 101.983232 406.426624 101.983232 416.451584 112.078848L494.854144 191.038464 494.854144 81.486848C494.854144 71.972864 502.637568 64.256 512.236544 64.256 521.834496 64.256 529.61792 71.972864 529.61792 81.486848L529.61792 190.870528 607.859712 112.078848C617.883648 101.983232 634.125312 101.983232 644.151296 112.078848 654.17728 122.166272 654.17728 138.539008 644.151296 148.627456L538.766336 254.754816C536.08448 257.45408 532.95104 259.407872 529.61792 260.66432L529.61792 477.302784 719.143936 367.110144C719.13472 364.858368 719.389696 362.5728 719.995904 360.292352L758.569984 215.328768C762.227712 201.53856 776.31488 193.327104 789.999616 197.054464 803.693568 200.748032 811.813888 214.91712 808.14592 228.70528L780.86656 331.224064 872.016896 278.227968C880.188416 273.456128 890.665984 276.301824 895.392768 284.537856 900.114432 292.783104 897.314816 303.315968 889.127936 308.078592L790.936576 365.167616 903.84896 395.628544C917.541888 399.322112 925.663232 413.4912 921.99424 427.281408 918.928384 438.823936 908.553216 446.446592 897.22368 446.446592Z",
                      "p-id": "2280",
                    },
                  }),
                ]
              ),
              _c(
                "svg",
                {
                  staticClass: "svg",
                  class: { active: _vm.air.mode === "heat" },
                  attrs: {
                    t: "1679966976175",
                    viewBox: "0 0 1024 1024",
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "p-id": "2550",
                    width: "32",
                    height: "32",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeMode("heat")
                    },
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M264.940168 289.852458a29.357102 29.357102 0 0 1-19.571402-8.807131l-92.377015-92.377016a27.987104 27.987104 0 0 1 1.761426-39.142803 29.357102 29.357102 0 0 1 37.381377 0l92.377016 92.377016a27.987104 27.987104 0 0 1 0 39.142803 22.89854 22.89854 0 0 1-19.571402 8.904988m590.077758 591.839184a36.598521 36.598521 0 0 1-19.571401-7.143562l-94.236299-92.377015a27.693533 27.693533 0 0 1 37.381377-40.90423l1.761426 1.859284 94.138442 92.377015a27.595676 27.595676 0 0 1 0 39.142803 36.500664 36.500664 0 0 1-19.571402 7.143562m-684.314057 0a27.693533 27.693533 0 0 1-19.571401-46.188508L243.509483 743.713261a27.595676 27.595676 0 1 1 39.142803 39.142803l-94.236298 92.377015a26.519249 26.519249 0 0 1-17.712119 7.143562m590.077758-591.839184a26.617106 26.617106 0 0 1-26.617106-28.47639 28.378532 28.378532 0 0 1 8.904988-19.571401l94.138442-92.377016a27.987104 27.987104 0 0 1 39.142803 1.761426 29.357102 29.357102 0 0 1 0 37.381377l-92.377016 93.5513a28.182818 28.182818 0 0 1-23.192111 7.143562M160.037455 540.562112H28.41978A26.714963 26.714963 0 0 1 1.802674 512.085723a26.127821 26.127821 0 0 1 26.617106-26.617106h131.617675a26.617106 26.617106 0 0 1 26.617107 28.378532 27.399962 27.399962 0 0 1-26.617107 26.714963m835.307421 0H863.922914a26.714963 26.714963 0 0 1-26.714963-28.476389 26.127821 26.127821 0 0 1 26.714963-26.617106h131.421962a26.617106 26.617106 0 0 1 26.714963 28.378532 25.247108 25.247108 0 0 1-26.714963 26.714963m-483.41362 483.413619a27.595676 27.595676 0 0 1-28.378532-26.617106V865.838807a27.693533 27.693533 0 1 1 55.093495-5.382136v135.140528a25.736393 25.736393 0 0 1-26.714963 28.378532m0-835.30742a27.693533 27.693533 0 0 1-28.378532-26.714963V30.433529a27.693533 27.693533 0 0 1 55.093495-5.382135v135.140528a25.83425 25.83425 0 0 1-26.714963 28.476389m0 110.186991a214.20899 214.20899 0 1 0 215.285418 213.230421 214.20899 214.20899 0 0 0-215.285418-213.230421m0 483.41362a268.128202 268.128202 0 0 1-268.323916-268.030345 268.421773 268.421773 0 0 1 536.745689 0 266.953918 266.953918 0 0 1-268.421773 268.030345",
                      "p-id": "2551",
                    },
                  }),
                ]
              ),
              _c(
                "svg",
                {
                  staticClass: "svg",
                  class: { active: _vm.air.mode === "wind" },
                  attrs: {
                    t: "1679967000470",
                    viewBox: "0 0 1024 1024",
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "p-id": "2777",
                    width: "32",
                    height: "32",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeMode("wind")
                    },
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M41.890909 549.236364c-4.654545 0-9.309091 0-16.290909-2.327273-9.309091-4.654545-25.6-16.290909-25.6-30.254546 0-11.636364 11.636364-27.927273 20.945455-34.90909 6.981818-4.654545 16.290909-4.654545 23.272727-4.654546h772.654545c65.163636 0 111.709091-30.254545 128-83.781818 18.618182-58.181818-11.636364-123.345455-69.818182-146.618182-13.963636-4.654545-27.927273-9.309091-44.218181-9.309091-46.545455 0-88.436364 25.6-107.054546 67.490909-2.327273 4.654545-4.654545 9.309091-4.654545 13.963637-2.327273 4.654545-2.327273 6.981818-4.654546 11.636363-6.981818 16.290909-18.618182 25.6-30.254545 25.6-4.654545 0-11.636364-2.327273-16.290909-4.654545-11.636364-6.981818-23.272727-30.254545-20.945455-44.218182 13.963636-67.490909 81.454545-130.327273 153.6-139.636364 9.309091 0 18.618182-2.327273 25.6-2.327272 95.418182 0 172.218182 62.836364 190.836364 153.6 18.618182 102.4-41.890909 197.818182-144.290909 221.090909-20.945455 4.654545-41.890909 4.654545-62.836364 4.654545H48.872727c0 4.654545-2.327273 4.654545-6.981818 4.654546zM672.581818 984.436364c-58.181818 0-114.036364-30.254545-141.963636-81.454546-6.981818-11.636364-23.272727-39.563636 6.981818-58.181818 6.981818-4.654545 13.963636-6.981818 20.945455-6.981818 16.290909 0 27.927273 13.963636 34.90909 27.927273 18.618182 30.254545 44.218182 46.545455 76.8 46.545454h16.29091c37.236364-4.654545 62.836364-27.927273 74.472727-67.490909 6.981818-25.6 2.327273-51.2-13.963637-72.145455-13.963636-20.945455-37.236364-34.909091-62.836363-37.236363-27.927273-2.327273-58.181818-2.327273-81.454546-2.327273h-558.545454c-4.654545 0-11.636364 0-18.618182-4.654545-9.309091-4.654545-23.272727-18.618182-23.272727-30.254546s11.636364-25.6 20.945454-32.581818c6.981818-4.654545 13.963636-4.654545 20.945455-4.654545h609.745454c97.745455 0 162.909091 51.2 179.2 137.30909 13.963636 76.8-30.254545 153.6-102.4 179.2-18.618182 4.654545-37.236364 6.981818-58.181818 6.981819z",
                      "p-id": "2778",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M244.363636 365.381818H46.545455c-13.963636 0-27.927273 0-37.236364-9.309091-6.981818-6.981818-9.309091-16.290909-9.309091-25.6 0-37.236364 32.581818-37.236364 53.527273-37.236363h370.036363c46.545455 0 83.781818-32.581818 90.763637-79.127273 4.654545-46.545455-20.945455-86.109091-67.490909-100.072727-6.981818-2.327273-13.963636-2.327273-20.945455-2.327273-27.927273 0-55.854545 13.963636-72.145454 37.236364-2.327273 2.327273-4.654545 6.981818-6.981819 9.30909-2.327273 2.327273-4.654545 6.981818-6.981818 9.309091-9.309091 11.636364-20.945455 18.618182-30.254545 18.618182-6.981818 0-13.963636-2.327273-18.618182-9.309091-11.636364-9.309091-16.290909-34.909091-11.636364-46.545454 20.945455-53.527273 81.454545-93.090909 144.290909-93.090909h11.636364c88.436364 6.981818 153.6 81.454545 151.272727 167.563636-2.327273 88.436364-72.145455 155.927273-158.254545 158.254545h-74.472727c-18.618182 2.327273-93.090909 2.327273-109.381819 2.327273z",
                      "p-id": "2779",
                    },
                  }),
                ]
              ),
              _c(
                "svg",
                {
                  staticClass: "svg",
                  class: { active: _vm.air.windspeed === "auto" },
                  attrs: {
                    t: "1680169972297",
                    viewBox: "0 0 1024 1024",
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "p-id": "20577",
                    width: "32",
                    height: "32",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeSpeed("auto")
                    },
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M343.134964 724.45563a44.688952 44.688952 0 0 0 11.721692-12.362723 115.38541 115.38541 0 0 0 9.157572-17.033084c2.56412-6.135573 5.12824-12.454298 7.783937-19.04775l32.051502-81.410817h206.961132l42.949014 108.242503a44.872104 44.872104 0 0 0 12.087995 19.505629 28.571625 28.571625 0 0 0 21.520295 6.685028c13.553207 0 22.161325-3.937756 25.824354-11.721693a36.630289 36.630289 0 0 0-0.824182-28.571625l-164.8363-433.611044a35.165077 35.165077 0 0 0-14.102661-18.315145 47.344648 47.344648 0 0 0-26.556959-6.685028 43.681619 43.681619 0 0 0-25.366475 6.685028 35.439804 35.439804 0 0 0-13.736359 18.315145L303.665827 687.275886c-5.677695 16.025751-5.677695 27.472717 0 32.875685a32.143078 32.143078 0 0 0 24.267567 9.157572 26.190657 26.190657 0 0 0 15.20157-4.853513zM507.696536 302.199975l89.011602 242.584088H418.593359z",
                      "p-id": "20578",
                      fill: "#999999",
                    },
                  }),
                  _c("path", {
                    attrs: {
                      d: "M754.401532 910.629073a462.640548 462.640548 0 0 1-657.42211-191.576411 468.501395 468.501395 0 0 1 2.380969-426.926017v-0.732605a19.68878 19.68878 0 0 0 1.556787-6.776604 22.619203 22.619203 0 0 0-22.619203-22.527628 21.795022 21.795022 0 0 0-21.062416 15.018419A526.1941 526.1941 0 0 0 0.000733 503.666563V511.999954a509.344167 509.344167 0 0 0 109.341412 316.210969l4.578786 5.76927a511.084105 511.084105 0 0 0 397.988089 190.019624H523.081258a509.985197 509.985197 0 0 0 253.481599-74.817365l30.128412 51.923434L836.728106 888.284597l-112.546562-29.853686z m160.165938-714.840087c-1.465212-1.92309-3.021999-3.754605-4.578786-5.677695A511.084105 511.084105 0 0 0 511.90902 0.000092h-11.263814A509.06944 509.06944 0 0 0 247.255182 75.000608l-30.128412-52.01501-29.945261 112.546562 112.546562 30.036837-30.219988-52.289737a462.548973 462.548973 0 0 1 657.422109 191.667986 468.318243 468.318243 0 0 1-2.014666 426.834441V732.605869a20.696113 20.696113 0 0 0-1.556787 6.776603 22.710779 22.710779 0 0 0 22.619204 22.619204 21.886598 21.886598 0 0 0 21.062416-15.109994 526.1941 526.1941 0 0 0 57.14325-226.558337v-0.64103-7.600785a509.06944 509.06944 0 0 0-109.616139-316.302544z",
                      "p-id": "20579",
                      fill: "#999999",
                    },
                  }),
                ]
              ),
              _c(
                "svg",
                {
                  staticClass: "svg",
                  class: { active: _vm.air.windspeed === "low" },
                  attrs: {
                    t: "1679650057641",
                    viewBox: "0 0 1024 1024",
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "p-id": "9570",
                    width: "32",
                    height: "32",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeSpeed("low")
                    },
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M691.4 129.4c18.2 0 36.3 3.7 52.3 10.6 14.2 6.2 26.3 14.9 34.2 24.4 11.8 14.5 9.7 25.2 8.9 28.8-6.6 32.2-18.6 47.4-28.4 57-14.9 14.6-36.1 26.5-60.7 40.1-23.5 13.1-50.2 27.9-78 48.9-12.1 9.1-23.2 19.2-33 29.9l-28.4 31.1-1.6-6.2c-10.3-40.3-14.4-77.3-12.1-110 2.6-36.2 13.2-67.2 31.5-92.2 15.8-21.6 34.6-37.9 55.9-48.5 18.6-9.2 38.6-13.9 59.4-13.9M566.7 432.8l37.1 16c31.6 13.6 51.9 44.6 51.9 79 0 1.8-0.1 3.8-0.2 5.8l-2.4 36.6-28.3 23.6c-15.6 13.1-34.7 20-55.1 20-16.2 0-32-4.5-45.7-13.1l-32.6-20.5-6.4-37.7c-0.8-4.8-1.2-9.7-1.2-14.6 0-16.2 4.5-32 13.1-45.6 8.3-13.3 20.2-24.1 34.1-31.2l35.7-18.3m-358.8 73.4c29.4 0 54.5 15 89.2 35.8 23.1 13.8 49.3 29.5 81.3 43.1 15.7 6.7 31.7 11.6 47.6 14.7l36.6 7.2-0.7 0.7c-27.6 27.8-55.7 49.5-83.3 64.6-30.6 16.7-60.8 25.2-89.8 25.2-5.4 0-10.9-0.3-16.4-0.9-20.2-2.2-38.7-7.4-55-15.6-14.5-7.2-27.4-16.8-38.3-28.4-19.5-20.8-32.3-48.5-35.3-76-1.9-17.3 0.3-33.4 6-45.3 6.6-13.8 15.7-16.9 18.6-17.9 14.6-4.8 27.5-7.2 39.5-7.2m484.7 79.1h0.2c42 10.9 77.8 26 106.3 44.6 31.8 20.8 54.5 46.2 67.4 75.6 28.8 65.3 7.7 114-7.5 137.3-10.5 16.2-24.2 29.7-39.6 39.1-13.2 8.1-26.9 12.6-38.6 12.6-8.6 0-15.4-2.4-21-7.3-24.6-21.8-31.7-39.8-35.2-53.1-5.3-20.2-4.9-44.5-4.4-72.6 0.4-26.9 0.9-57.5-3.3-92-2.4-19.2-6.8-37.7-13.3-54.9l-11-29.3m-1.2-505.9c-53.8 0-112.1 23.4-155.6 82.8-51.8 70.8-48.4 163-27.5 244.3-44.2 22.4-74.6 68.4-74.6 121.4 0 7.8 0.7 15.5 1.9 23-12.1-2.4-24.7-6.2-37.7-11.7-78.7-33.4-121.9-82.9-190.1-82.9-16.7 0-34.8 3-55.3 9.8C48 501 78.5 725.9 267 746.4c7.3 0.8 14.6 1.2 21.8 1.2 80.9 0 153-48.5 208.6-104.5 20.9 13.2 45.7 20.8 72.3 20.8 33.2 0 63.6-11.9 87.2-31.6 4.9 13 8.5 27.4 10.5 43.4 12.9 105.6-23.1 176 59.4 249.1 15.4 13.7 34.3 19.9 54.2 19.9 86.5 0 193.5-118.2 131.3-259.2-36.7-83.4-123.1-126.7-206.9-148.5 0.2-3 0.3-6.1 0.3-9.1 0-56-33.8-104-82.1-124.9 7.5-8.2 16.2-16.1 26.2-23.7 85-64 164-68 186-176C849.3 137.2 776 79.4 691.4 79.4z",
                      "p-id": "9571",
                    },
                  }),
                ]
              ),
              _c(
                "svg",
                {
                  staticClass: "svg",
                  class: { active: _vm.air.windspeed === "middle" },
                  attrs: {
                    t: "1679650045156",
                    viewBox: "0 0 1024 1024",
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "p-id": "9424",
                    width: "32",
                    height: "32",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeSpeed("middle")
                    },
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M632.7 112.6c18.2 0 36.3 3.7 52.3 10.6 14.2 6.2 26.3 14.9 34.2 24.4 11.8 14.5 9.7 25.2 8.9 28.8-6.6 32.2-18.6 47.4-28.4 57-14.9 14.6-36.1 26.5-60.7 40.1-23.5 13.1-50.2 27.9-78 48.9-12.3 9.3-23.6 19.5-33.5 30.4l-27.9 30.7-1.3-5.2c-10.5-40.5-14.7-77.7-12.4-110.7 2.5-36.4 13.1-67.6 31.5-92.8 15.8-21.6 34.6-37.9 55.9-48.5 18.6-9 38.6-13.7 59.4-13.7M173.2 316.8c1.9 0 3.8 0.2 5.8 0.6 32.2 6.6 47.4 18.6 57 28.4 14.6 14.9 26.5 36.1 40.1 60.7 13.1 23.5 27.9 50.2 48.9 78 6.5 8.6 13.5 16.7 20.8 24.2l37.2 38c-34 9-65.9 13.5-94.9 13.5-21.6 0-41.6-2.6-59.6-7.6-18.9-5.3-36.1-13.6-51-24.5-63.7-46.6-70.6-111.5-55.8-156.7 10.2-31.7 31.9-54.6 51.5-54.6m335.1 100.4l36.9 15.5c20.2 8.4 36.2 24.1 45.2 44l16.6 36.7-17.6 36.2c-7.2 14.9-18.5 27.3-32.7 35.9l-32 19.5 0.8 3-42.1-14.8c-16.2-5.7-30.2-16-40.5-29.9l-20.5-27.5-7.7 2.1 14.7-50.1c6.6-22.5 22.4-41.6 43.3-52.3l35.6-18.3m227.6 75.6c44.3 0 81.5 10.8 110.6 32.1 63.7 46.6 70.6 111.5 55.8 156.7-10.3 31.6-32 54.5-51.6 54.5-1.9 0-3.8-0.2-5.8-0.6-32.2-6.6-47.4-18.6-57-28.4-14.6-14.9-26.5-36.1-40.1-60.7-13.1-23.5-27.9-50.2-48.9-78-9.5-12.6-20-24.1-31.2-34.2l-30.2-27.1 10.4-2.6c31.5-7.7 61.1-11.7 88-11.7M534.6 641.5c11.1 41.2 15.7 79.1 13.6 112.6-2.3 37.3-12.9 69.3-31.7 94.9-15.8 21.6-34.6 37.9-55.9 48.5-18.6 9.2-38.6 13.9-59.4 13.9-18.2 0-36.3-3.7-52.3-10.6-14.2-6.2-26.3-14.9-34.2-24.4-11.8-14.5-9.7-25.2-8.9-28.8 6.6-32.2 18.6-47.4 28.4-57 14.9-14.6 36.1-26.5 60.7-40.1 23.5-13.1 50.2-27.9 78-48.9 10.9-8.2 21.1-17.2 30.1-26.8l31.6-33.3m98.1-578.9c-53.8 0-112.1 23.4-155.6 82.8-52.1 71.2-48.4 163.9-27.2 245.6-32.8 16.9-57.9 46.7-68.4 82.7-5.7-5.8-11.2-12.2-16.6-19.3-64-85-68-164-176-186-5.3-1.1-10.6-1.6-15.7-1.6-100.2 0-170.8 195.1-25.3 301.6 41.5 30.4 90.4 41.8 140.2 41.8 38.7 0 78-6.9 114.7-17.1 16 21.5 38.2 38.2 64 47.2-7 7.3-14.9 14.5-23.9 21.3-85 64-164 68-186 176-13.5 66 59.8 123.8 144.4 123.8 53.8 0 112.1-23.4 155.6-82.8 53.1-72.6 48.2-167.7 25.9-250.4 22.2-13.5 40.1-33.2 51.6-56.7 8.6 7.7 16.9 16.7 24.7 27.1 64 85 68 164 176 186 5.3 1.1 10.6 1.6 15.7 1.6 100.1 0 170.7-195.1 25.3-301.6-41.5-30.4-90.4-41.8-140.2-41.8-33.6 0-67.6 5.2-99.9 13.2-14.1-31.3-39.8-56.2-71.5-69.5 7.6-8.3 16.4-16.4 26.6-24.1 85-64 164-68 186-176 13.4-66-59.8-123.8-144.4-123.8z",
                      "p-id": "9425",
                    },
                  }),
                ]
              ),
              _c(
                "svg",
                {
                  staticClass: "svg",
                  class: { active: _vm.air.windspeed === "high" },
                  attrs: {
                    t: "1679650064790",
                    viewBox: "0 0 1024 1024",
                    version: "1.1",
                    xmlns: "http://www.w3.org/2000/svg",
                    "p-id": "9716",
                    width: "32",
                    height: "32",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.changeSpeed("high")
                    },
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M603.7 89c18.2 0 36.3 3.7 52.3 10.6 14.2 6.2 26.3 14.9 34.2 24.4 11.8 14.5 9.7 25.2 8.9 28.8-6.6 32.2-18.6 47.4-28.4 57-14.9 14.6-36.1 26.5-60.7 40.1-23.5 13.1-50.2 27.9-78 48.9-20.4 15.3-37.6 33.1-51.3 52.8l-8.8 12.7c-11.2-40-16.4-77-15.5-110.2 1.2-40.8 12-75.4 32-102.8 15.8-21.6 34.6-37.9 55.9-48.5 18.6-9.1 38.6-13.8 59.4-13.8M204.2 206.7c5.1 0 9.8 1.2 14.2 3.7 28.6 16.2 39.3 32.4 45.5 44.6 9.3 18.7 14 42.5 19.4 70.1 5.2 26.4 11.1 56.4 22.4 89.3 6.5 18.9 15 36.5 25.4 52.4l16.2 24.9c-41.6-1.8-78.4-8.5-109.5-19.9-37.5-13.7-66.4-34.5-86-61.5-18.4-25.5-28.5-52.4-30-80-1.4-23.7 3.7-47.5 14.6-68.8 8.7-17 21-31.9 34.6-41.8 11.4-8.4 23.2-13 33.2-13m567.5 186.4c17 0 33.6 2.6 49.1 7.7 19.3 6.3 36.3 15.3 50.6 26.7 12.7 10.1 23.3 22.1 31.6 35.8 14.7 24.4 21.5 54.1 18.7 81.7-1.8 17.3-7.2 32.6-15.3 43.1-9.3 12.2-18.8 13.2-21.9 13.6-6.2 0.7-12.2 1.1-17.8 1.1-19.3 0-34.9-4.1-50.6-13.4-16.6-9.8-32.8-24.9-51.6-42.3-19.7-18.3-42.1-39.1-70.6-59.1-16.7-11.7-34.4-21.1-52.5-27.9L614.6 450c25.6-16.9 50.8-30.3 75.1-39.7 28.9-11.5 56.5-17.2 82-17.2m-293.4 27.6l31.1 7.9c13.8 3.5 26.7 10.6 37.2 20.4l26 24.2 1.3 35.4c0.1 1.3 0.1 2.4 0.1 3.4 0 13.8-3.1 26.9-9.4 39.1l-17.3 33.8-36.4 10c-7.4 2-15.1 3.1-22.9 3.1-3.9 0-7.8-0.3-11.7-0.8l-33.5-4.5-21.5-26.4c-8.4-10.2-14.3-22.4-17.2-35.2l-7.9-34.8 18.9-30c8.4-13.4 20.4-24.2 34.5-31.2l28.7-14.4m98.5 191.2l1.1 0.8c33.5 26.9 59.7 55.1 77.9 83.6 20.3 31.6 30.5 63.8 30.3 95.7-0.2 55.3-23.9 89-43.7 107.6-23.7 22.2-55.2 35.4-84.3 35.4-11.7 0-22-2.2-29.9-6.4-6.3-3.4-10.7-7.9-13.5-13.9-13.6-29.9-12.8-49.3-10.5-62.8 3.4-20.6 13.6-42.6 25.5-68.1 11.3-24.4 24.2-52.1 34.4-85.4 5.2-17.1 8.6-34.3 9.9-51.3l2.8-35.2M419.3 639c-14.6 39.2-32.4 72.4-52.9 98.6-24.7 31.6-53.5 52.9-85.4 63.1-17.2 5.5-34.1 8.3-50.5 8.3-36.2 0-62.9-13.7-78.9-25.2-20.4-14.6-36.1-34.4-44.4-55.6-4.8-12.3-6.6-24-5.2-33.8 1.1-7.8 4.1-14 9.3-18.7 27.9-25.5 50.5-30.8 76-30.8 15.9 0 33.2 2.1 53.2 4.5 24.7 3 52.7 6.4 84.3 6.4 2.5 0 5 0 7.5-0.1 22.6-0.4 44.3-3.7 64.7-10l22.3-6.7M603.7 39c-53.8 0-112.1 23.4-155.6 82.8-57 77.9-47.2 181.7-20.7 268.4-22.4 11.2-41.2 28.3-54.5 49.3-7.8-11.9-14.6-25.6-20-41.4-34.6-100.6-14-177-109.9-231.3-12.3-7-25.5-10.2-38.8-10.2-90.5 0-189.6 148.8-92.9 282.8 55.5 76.9 154.7 100.2 244.1 102.5 4.7 20.8 14.2 39.8 27.2 55.8-15.2 4.6-32.1 7.5-50.9 7.8-2.2 0-4.4 0.1-6.6 0.1-53.6 0-97-10.9-137.5-10.9-37.1 0-71.8 9.1-109.8 43.9C6.8 703.7 88.6 859 230.6 859c20.7 0 42.7-3.3 65.7-10.7 90.7-29.1 143.5-116.9 173.3-201.5 6 0.8 12.1 1.2 18.4 1.2 12.5 0 24.7-1.7 36.2-4.9-1 12.8-3.5 26.4-7.8 40.5-31.1 101.7-92.7 151.4-47 251.7 15.2 33.3 49.6 49.6 88.8 49.6 79 0 177.5-66.1 178-192.8 0.3-90.3-60-164.5-126.9-218.4 9.5-18.6 14.8-39.6 14.8-61.8 0-1.8 0-3.5-0.1-5.3 13.6 5.1 27.4 12.3 41.3 22 80.6 56.5 110.8 123.9 201.4 123.9 7.4 0 15.2-0.4 23.4-1.4 109.5-12.5 126.4-238.7-53.7-298-21.4-7.1-43.1-10.2-64.7-10.2-68.2 0-135.3 31.4-191.1 69.3-16.4-15.2-36.5-26.5-58.9-32.2 10.1-14.5 23.3-28.5 40.3-41.4 85-64 164-68 186-176C761.6 96.8 688.3 39 603.7 39z",
                      "p-id": "9717",
                    },
                  }),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }